"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _setContextTransform = _interopRequireDefault(require("../transform/setContextTransform"));

var _models = require("../../../models");

var _setCanvasTextDirection = _interopRequireDefault(require("../../../text/canvas/setCanvasTextDirection"));

var _getCanvasFontProperty = _interopRequireDefault(require("../../../utils/font/getCanvasFontProperty"));

var _isNumber = _interopRequireDefault(require("../../../utils/numbers/isNumber"));

var _getTextAlign = _interopRequireDefault(require("../../../utils/text/getTextAlign"));

var _isRTLText = _interopRequireDefault(require("../../../utils/string/isRTLText"));

var _text = require("../../../constants/text");

var _creative = require("../../../constants/creative");

var TextEffect = /*#__PURE__*/function () {
  function TextEffect() {
    (0, _classCallCheck2["default"])(this, TextEffect);
  }

  (0, _createClass2["default"])(TextEffect, null, [{
    key: "getAlignmentY",
    value: function getAlignmentY(contentFrameData) {
      var textHeight = contentFrameData.contentHeight,
          textRenderProperties = contentFrameData.textRenderProperties;
      var padding = textRenderProperties.padding,
          wrapProperties = textRenderProperties.wrapProperties;
      var wrapHeight = wrapProperties.get('height'); // todo(): support RTL

      switch (textRenderProperties.verticalAlignment) {
        case _text.VERTICAL_TEXT_ALIGNMENT.TOP:
          return padding;

        case _text.VERTICAL_TEXT_ALIGNMENT.BOTTOM:
          return wrapHeight - padding - textHeight;

        case _text.VERTICAL_TEXT_ALIGNMENT.MIDDLE:
          return 0.5 * (wrapHeight - textHeight);

        default:
          return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      /*
       * set up!!
       */
      var textCanvas = finalContext.canvas;
      var rotation = layerTransformData.rotation,
          scaleX = layerTransformData.scaleX,
          scaleY = layerTransformData.scaleY,
          translationX = layerTransformData.translationX,
          translationY = layerTransformData.translationY;
      var textRenderProperties = contentFrameData.textRenderProperties;
      var textString = textRenderProperties.textString,
          textWrapProperties = textRenderProperties.wrapProperties;
      var wrapWidth = textWrapProperties.get('width');
      var wrapHeight = textWrapProperties.get('height');
      var isRTL = (0, _isRTLText["default"])(textString);
      var textDirection = isRTL ? _text.TEXT_DIRECTION.RTL : _text.TEXT_DIRECTION.LTR;
      (0, _setContextTransform["default"])(effectContext, translationX, translationY, scaleX, scaleY, rotation, new _models.Rectangle(0, 0, textCanvas.width, textCanvas.height));
      effectContext.clearRect(-textCanvas.width / 2, -textCanvas.height / 2, textCanvas.width, textCanvas.height);
      effectContext.translate(-wrapWidth / 2, -wrapHeight / 2); // Set text direction and font properties on Text Effect Canvas.

      (0, _setCanvasTextDirection["default"])(effectContext, textDirection);
      effectContext.font = (0, _getCanvasFontProperty["default"])(textRenderProperties.fontName, textRenderProperties.renderedFontSize);
      effectContext.fillStyle = textRenderProperties.fillColor;
      effectContext.textAlign = (0, _getTextAlign["default"])(textRenderProperties.horizontalAlignment, isRTL);
    }
  }, {
    key: "drawTextLines",
    value: function drawTextLines(context, contentFrameData) {
      var repeat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var lines = contentFrameData.textLines,
          textRenderProperties = contentFrameData.textRenderProperties;
      var alignmentY = TextEffect.getAlignmentY(contentFrameData);
      var strokeColor = textRenderProperties.strokeColor,
          strokeWidth = textRenderProperties.strokeWidth;
      var hasStroke = (0, _isNumber["default"])(strokeWidth) && strokeWidth > 0;

      if (hasStroke) {
        context.strokeStyle = strokeColor;
        context.lineWidth = strokeWidth;
        context.lineJoin = _text.DEFAULT_STROKE_STYLE;
      }

      lines.forEach(function (lineData) {
        var line = lineData.line,
            x = lineData.x,
            y = lineData.y;
        var lineY = alignmentY + y;

        for (var i = 0; i < repeat; i++) {
          context.fillText(line, x, lineY);
        }

        if (!hasStroke) return;
        var shadowColor = context.shadowColor;
        context.shadowColor = _creative.TRANSPARENT_FILL_COLOR; // temporary remove shadow !

        context.strokeText(line, x, lineY);
        context.shadowColor = shadowColor;
      });
      context.lineJoin = _text.STROKE_STYLES.MITER;
    }
    /**
     * Checks if object is an instance of TextEffect
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isTextEffect",
    value: function isTextEffect(inputObject) {
      return inputObject instanceof TextEffect;
    }
  }]);
  return TextEffect;
}();

exports["default"] = TextEffect;